import React from 'react'
import { connect } from 'react-redux'
import { showMessage } from '../actions/messageBox'

class Statuspick extends React.Component {
    constructor(props) {
        super(props)
        this.handleChange = this.handleChange.bind(this)
        this.handleChangeString = this.handleChangeString.bind(this)
        this.textInput = HTMLInputElement
        this.state = {
            status: props.status,
            toggledListId: props.status === 1 ? true : false
        }



    }

    componentDidMount(){
        if(this.props.setRef && typeof this.props.setRef === "function"){
            this.props.setRef(this)
        }
    }

    handleToggle = () => {

        let getConnectionName = this.props.connectionName
        let getAuditList
        let getUserList
        let getConnectionList
        let getProviderList
        let getDatasourceList
        let getDatasourcemappingList
        let getScheduleList
        let endpoints = this.props.endpoints
        let getDatasourceId
        let getConnectionId
        let getFrequencyId
        let hasConnection
        let hasSchedule
        let epStatus = this.props.status
        let epName
        let oepName
        let hasIntegration
        let checkDatasourceId
        let checkDatatargetId
        let checkFrequencyId



        // this.props.dispatch(editEndpointList(
        //     endpoint.id,
        //     endpoint.name,
        //     this.props.auth.access_token,
        //     Object.assign({},list,{
        //         status: e.target.checked ? 1: 0
        //     })
        // ))
        if(this.props.endpointName=="datasources" || this.props.endpointName=="connections" || this.props.endpointName =="frequencies" ){
            for (let n in endpoints) {
                if (endpoints[n].name === "audits") {
                    getAuditList = endpoints[n].list
                } else if (endpoints[n].name === "users") {
                    getUserList = endpoints[n].list
                } else if (endpoints[n].name === "providers") {
                    getProviderList = endpoints[n].list
                } else if (endpoints[n].name === "connections") {
                    getConnectionList = endpoints[n].list
                } else if (endpoints[n].name === "datasources") {
                    getDatasourceList = endpoints[n].list
                } else if (endpoints[n].name === "datasourcemappings"){
                    getDatasourcemappingList = endpoints[n].list
                } else if (endpoints[n].name === "schedules"){
                    getScheduleList = endpoints[n].list
                } 
            }
 

            if(this.props.endpointName && this.props.endpointName === "connections"){
                getConnectionId = this.props.endpointId
                hasConnection = getDatasourceList.find(gdl => gdl.connection_id === getConnectionId)
                epName="Connection"
                oepName="Datasource"
            }else if(this.props.endpointName && this.props.endpointName === "datasources"){
                getDatasourceId = this.props.endpointId
                checkDatasourceId = getDatasourcemappingList.find(gdml => gdml.datasource_id===getDatasourceId)
                checkDatatargetId = getDatasourcemappingList.find(gdml => gdml.datatarget_id===getDatasourceId)
                if(checkDatasourceId || checkDatatargetId || checkDatasourceId && checkDatatargetId){
                    hasIntegration = true
                }else{
                    hasIntegration = false
                }
                epName="Datasource"
                oepName="Integration"
            }else if(this.props.endpointName && this.props.endpointName === "frequencies"){
                getFrequencyId = this.props.endpointId
                checkFrequencyId = getScheduleList.find(gsl => gsl.frequency_id === getFrequencyId)
                if(checkFrequencyId){
                    hasSchedule = true
                }else{
                    hasSchedule = false
                }
                epName="Frequency"
                oepName="Schedule"
            }

        }
        

        if(hasConnection && epStatus != 0){

            this.props.dispatch(
                showMessage({
                    type: "error",
                    title: "Error",
                    message: `Unable to deactivate ${epName} due to a related ${oepName}. `
                })
            )
        }else if(hasIntegration && epStatus !=0 ){
            this.props.dispatch(
                showMessage({
                    type: "error",
                    title: "Error",
                    message: `Unable to deactivate ${epName} due to a related ${oepName}. `
                })
            )
        }else if (hasSchedule && epStatus !=0){
            this.props.dispatch(
                showMessage({
                    type: "error",
                    title: "Error",
                    message: `Unable to deactivate ${epName} due to a related ${oepName}. `
                })
            )
        }else{
            if( (this.props.allowActivate && !this.state.status === true) || !this.state.status === false  ) {
                this.setState({
                    status: !this.state.status,
                    toggledListId: !this.state.toggledListId
                },()=>{
                    let nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set
                    nativeInputValueSetter.call(this.textInput, this.state.status)
    
                    var status2 = new Event('input', { bubbles: true })
    
    
                    this.textInput.dispatchEvent(status2)
                })
            } else {
                this.props.dispatch(
                    showMessage({
                        type: "error",
                        title: "Action not allowed",
                        message: this.props.activateError
                    })
                )
            }
        }


    }

    handleChange(event) {

        let numStatus

        if (event.target.checked === true) {
            numStatus = 1
        } else {
            numStatus = 0
        }

        if( (this.props.allowActivate && numStatus===1) || numStatus === 0  ) {

            let nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set
            nativeInputValueSetter.call(this.textInput, numStatus)

            var status2 = new Event('input', { bubbles: true })


            this.textInput.dispatchEvent(status2)

            this.setState({
                status: numStatus
            })

        }


    }

    handleChangeString(event) {

        this.props.onChange(event)
    }

    render() {
        //console.log(this.state.status)
        return (
            <div className={"input-group" + (this.props.showText ? "":" align-items-center")}>
                <input type="number" className="d-none" onChange={this.handleChangeString} id={this.props.id} name={this.props.name} value={this.state.status} ref={inp => { this.textInput = inp }} />
                {/* <label htmlFor="status">hello</label>
                <input
                    className="form-control-plaintext"
                    type="text"
                    defaultChecked={this.state.status === 1}
                    onChange={this.handleChange}
                    readOnly
                    id="status"
                /> */}
                { this.props.showText ?
                <div>
                    Off
                </div> : null
                }
                <div className={this.props.showText ? "px-3":"input-group justify-content-center"}>
                    <label className="switch">
                        <input type="checkbox"
                            checked={this.state.toggledListId}
                            onChange={this.handleChange}
                            onClick={this.handleToggle}

                        />
                        <span className="slider round"></span>
                    </label>
                </div>
                { this.props.showText ?
                <div>
                    On
                </div> : null
                }
            </div>
        )
    }
}

function mapStateToProps(state,ownProps){
    let allowActivate = ownProps.allowActivate === undefined ? true : ownProps.allowActivate
    let activateError = ownProps.activateError === undefined ? "You cannot activate at this time" : ownProps.activateError

    return {
        ...ownProps,
        allowActivate,
        activateError
    }
}

export default connect(mapStateToProps)(Statuspick)


// WEBPACK FOOTER //
// ./src/components/statuspick.js